export default function LevelABlockDivider() {
    // Used in

    // BUILD
    return (
        <div className={"w-full flex justify-center"}>
            <div className={"h-[40px] min-h-[40px] w-[4px] min-w-[4px] bg-greyLight3"}>
            </div>
        </div>
    );
}